<template>
  <div
    v-if="agreements.length"
    class="c-agreements"
  >
    <v-checkbox
      v-for="agreement in agreements"
      :key="agreement.id"
      v-model="checkedAgreements"
      :required="agreement.obligatory"
      :value="agreement.id"
      :tabindex="TabIndex.ENABLED"
    >
      <div
        v-dompurify-html="agreement.description"
        class="o-typography--richtext"
      ></div>
    </v-checkbox>
    <div class="c-agreements__required u-color-accent">
      * {{ $t('common.required') }}
    </div>
  </div>
</template>
<script>
  import { TabIndex } from '@/shared/enums';
  import VCheckbox from '../checkbox/index.vue';

  export default {
    components: {
      VCheckbox,
    },
    props: {
      value: Array,
      agreements: {
        type: Array,
        default: () => [],
      },
    },
    enums: {
      TabIndex,
    },
    data() {
      return {
        checkedAgreements: [],
      };
    },
    computed: {
      accepted() {
        return this.agreements
          .filter((agreement) => agreement.obligatory)
          .every((agreement) => this.checkedAgreements.includes(agreement.id));
      },
    },
    watch: {
      accepted: 'emitAccept',
      agreements: 'init',
      checkedAgreements: 'emitInput',
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.checkedAgreements = this.agreements.filter((agreement) => agreement.value).map((agreement) => agreement.id);
        this.emitAccept();
        this.emitInput();
      },
      emitAccept() {
        this.$emit('accept', this.accepted);
      },
      emitInput() {
        this.$emit('input', this.agreements.map((agreement) => {
          return {
            id: agreement.id,
            value: this.checkedAgreements.indexOf(agreement.id) !== -1,
          };
        }));
      },
    },
  };
</script>
